export const NAME = 'receipts';

const CONTEXT = 'MODULE::RECEIPTS';

const RESET = `${CONTEXT}::RESET`;

const CHANGE = `${CONTEXT}::CHANGE`;
const MOUNT = `${CONTEXT}::MOUNT`;
const UNMOUNT = `${CONTEXT}::UNMOUNT`;

export const ACTION_TYPES = {
  RESET,
  CHANGE,
  MOUNT,
  UNMOUNT,
};
